export default function Button({ children, variant = 'primary', ...props }) {
  const base =
    'inline-flex items-center justify-center rounded-none px-6 py-3 font-semibold uppercase tracking-wider transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 cursor-pointer';
  const styles =
    variant === 'primary'
      ? 'bg-[#F59E0B] text-[#0F172A] hover:bg-[#FBBF24] focus:ring-[#F59E0B]'
      : 'border-2 border-[#F59E0B] text-[#F59E0B] hover:bg-[#F59E0B] hover:text-[#0F172A] focus:ring-[#F59E0B]';

  return (
    <button className={`${base} ${styles}`} {...props}>
      {children}
    </button>
  );
}
